export default function setCssVariables(variableObj) {
  Object.keys(variableObj).map((key) => {
    const value = variableObj[key];
    return document.documentElement.style.setProperty(key, value);
  });
}
